import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Pursuits Dashboard",
  published_at: "2026-02-23",
  summary: "A completely redesigned pursuits experience with pipeline analytics, multiple views, and an AI-powered pipeline assistant.",
  tags: ["Pursuit"],
  draft: false
};
export const sections = [];
function _createMdxContent(props) {
  const _components = {
    h3: "h3",
    img: "img",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "The Pursuits Dashboard has been completely rebuilt with a clearer view of pipeline health and faster ways to take action."
    }), "\n", _jsx(_components.h3, {
      children: "Dashboard Overview"
    }), "\n", _jsx(_components.p, {
      children: "You now have four ways to view your pipeline:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Dashboard with key performance indicators"
      }), "\n", _jsx(_components.li, {
        children: "Sortable List"
      }), "\n", _jsx(_components.li, {
        children: "Drag-and-drop Board organized by stage"
      }), "\n", _jsx(_components.li, {
        children: "Calendar with upcoming deadlines"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "At a glance, see total pipeline value by stage, win rates, deal velocity, and stage conversion rates. Filter by time period to compare quarters and track trends."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/changelog/2026-02-23-pursuits-dashboard/dashboard-overview.png",
        alt: "Pursuits Dashboard with pipeline KPIs and stage breakdown"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Alerts and Activity"
    }), "\n", _jsx(_components.p, {
      children: "The new alerts system flags pursuits that need attention, including overdue items, opportunities due this week, and stale pursuits that have not been updated recently. An activity feed also shows what your team has been working on across all pursuits."
    }), "\n", _jsx(_components.h3, {
      children: "Ask AI Pipelines"
    }), "\n", _jsx(_components.p, {
      children: "The AI pipeline assistant can answer questions about your pipeline in plain language. Ask questions like \"what's our win rate this quarter?\" or \"which pursuits are at risk?\" and get answers drawn from your real data. You can also ask directly about specific pursuit pipeline status and next actions without leaving chat."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "6fcec820-e9c4-5fab-8f46-1ac8914813c9"
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "AI (3)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Playbooks can now be quick-applied directly from the chat window"
        }), "\n", _jsx(_components.li, {
          children: "Smoother scrolling in long AI conversations"
        }), "\n", _jsx(_components.li, {
          children: "Copy text directly from AI chat responses"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Documents (3)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Document library now supports a folder view for easier navigation"
        }), "\n", _jsx(_components.li, {
          children: "Browse and attach files from the file explorer within chat"
        }), "\n", _jsx(_components.li, {
          children: "Fixed images not rendering in certain chat contexts"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Performance (3)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Significantly faster page load times across the entire platform"
        }), "\n", _jsx(_components.li, {
          children: "Faster loading for large pursuit tables"
        }), "\n", _jsx(_components.li, {
          children: "Smarter search results across opportunities and pursuits"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Reliability (4)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Improved overall platform performance"
        }), "\n", _jsx(_components.li, {
          children: "Fixed pursuit stage not reflecting correctly in the proposal outline tool"
        }), "\n", _jsx(_components.li, {
          children: "Fixed sidebar flyout panel occasionally getting stuck open"
        }), "\n", _jsx(_components.li, {
          children: "Fixed new chat button sometimes not responding"
        }), "\n"]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
